import { render } from "./Notice.vue?vue&type=template&id=58ab0e78"
import script from "./Notice.vue?vue&type=script&lang=js"
export * from "./Notice.vue?vue&type=script&lang=js"

import "./Notice.vue?vue&type=style&index=0&id=58ab0e78&lang=css"
script.render = render

export default script